import { ErrorCodes } from 'enums';

export class NetworkError extends Error {
  code: ErrorCodes = ErrorCodes.SERVER_ERROR;

  constructor() {
    super('Ocorreu um erro no servidor, tente mais tarde.');
    this.name = 'NetworkError';

    return this;
  }
}
